<template>
  <div class="w1200">
    <div class="bg1 fl w240" style="">
      <div class="hd ys4">
        <div class="tag">
          <el-popover placement="bottom" width="200" trigger="hover">
            <el-tabs v-model="activeName" class="popoverSection">
              <el-tab-pane
                :label="section.label"
                v-for="(section, i) in sectionData"
                :key="'section' + i"
                :name="section.id"
                ><ul>
                  <li
                    v-for="(subject, j) in section.children"
                    :key="'subject_' + i + '_' + j"
                    @click="goResource(section, subject)"
                  >
                    <span>{{ subject.label }}</span>
                  </li>
                </ul></el-tab-pane
              >
            </el-tabs>
            <!-- <el-button slot="reference"
                  > <i class="el-icon-arrow-down"></i
                ></el-button> -->
            <span slot="reference"
              >{{ breadcrumb[1] }} <i class="el-icon-arrow-down"></i
            ></span>
          </el-popover>
        </div>
        <el-tree
          :props="defaultProps"
          :data="
            tree
              .filter((el) => el.id == clickData.sectionId)[0]
              .children.filter((el) => el.id == clickData.subjectId)[0].children
          "
          @node-click="treeClick"
          highlight-current
          ><span class="span-ellipsis" slot-scope="{ node }">
            <span :title="node.label">{{ node.label }}</span></span
          ></el-tree
        >
      </div>
    </div>
    <div class="bg fr w940">
      <el-form ref="form" :model="search" label-width="120px" size="small">
        <el-form-item label="资源名称：">
          <el-input v-model="search.resourceName" style="width: 250px"></el-input>
        </el-form-item>
        <el-form-item label="资源类型：">
          <el-radio-group v-model="search.resourceTypeId">
            <el-radio-button label="">全部</el-radio-button>
            <el-radio-button
              v-for="(resource, i) in resourceTypeData"
              :key="'resource' + i"
              :label="resource.code"
              >{{ resource.name }}</el-radio-button
            >
          </el-radio-group>
        </el-form-item>
        <el-form-item label="文档类型：">
          <el-radio-group v-model="search.fileType">
            <el-radio-button label="">全部</el-radio-button>
            <el-radio-button
              v-for="(resource, i) in fileTypeData"
              :key="'resource' + i"
              :label="resource.key"
              >{{ resource.value }}</el-radio-button
            >
          </el-radio-group>
        </el-form-item>
        <el-form-item label="共享学校：">
          <el-input v-model="search.orgName" style="width: 250px"></el-input>
        </el-form-item>
        <el-form-item label="作者：">
          <el-input v-model="search.userName" style="width: 250px"></el-input>
        </el-form-item>
        <el-form-item label="共享年份：">
          <el-select v-model="search.year" placeholder="请选择" style="width: 250px">
            <el-option
              v-for="item in yearData"
              :key="item.code"
              :label="item.name"
              :value="item.code"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="getData">查询</el-button>
          <el-button
            type=""
            @click="
              search = {
                resourceName: '',
                resourceTypeId: '',
                fileType: '',
                orgName: '',
                userName: '',
                year: '',
              }
            "
            >重置</el-button
          >
        </el-form-item>
      </el-form>
    </div>
    <div class="bg fr w940">
      <el-radio-group v-model="sortOrder" @change="getData" size="small">
        <el-radio-button label="最新">最新<i class="el-icon-bottom"></i></el-radio-button>
        <el-radio-button label="下载量"
          >下载量<i class="el-icon-bottom"></i
        ></el-radio-button>
        <el-radio-button label="收藏量"
          >收藏量<i class="el-icon-bottom"></i
        ></el-radio-button>
      </el-radio-group>
      <el-divider></el-divider>
      <div class="bd ys4">
        <ul>
          <li v-for="d in data" :key="d.resourceId">
            <div class="icon">
              <svg class="icon" aria-hidden="true">
                <use :xlink:href="'#icontbd' + d.fileType"></use>
              </svg>
              <em v-if="d.fileType == 1 || d.fileType == 2 || d.fileType == 3"
                >- {{ d.filePage }}页 -</em
              >
            </div>
            <div class="title">
              <h5>{{ d.resourceName }}</h5>
              <span class="catalog">
                <i v-if="d.versionName">{{ d.versionName }}</i>
                <i v-if="d.volumeName">/{{ d.volumeName }}</i>
                <i v-if="d.firstChapterName">/{{ d.firstChapterName }}</i>
                <i v-if="d.secondChapterName">/{{ d.secondChapterName }}</i>
                <i v-if="d.thirdChapterName">/{{ d.thirdChapterName }}</i>
                <i v-if="d.fourthChapterName">/{{ d.fourthChapterName }}</i>
              </span>
              <div>
                <span class="time">时间：{{ d.createTime.split(" ")[0] }}</span>
                <span class="download">下载量：{{ d.downloadNumber }}</span>
                <span class="collection">收藏量：{{ d.favoriteNumber }}</span>
                <span class="attribute">浏览量：{{ d.visitedNumber }}</span>
                <span class="size">大小：{{ unit(d.fileSize) }}</span>
              </div>
              <span class="school">学校：{{ d.schoolName }}</span>
              <span class="author">作者：{{ d.createUserName }}</span>
              <!-- <span>作者：{{ d.resourceId }}</span> -->
            </div>
            <div class="operate">
              <el-button
                type="primary"
                size="mini"
                @click="copy(d)"
                :disabled="value.map((el) => el.resourceId).includes(d.resourceId)"
                >引用</el-button
              >
            </div>
          </li>
          <!-- // -->
        </ul>
        <el-pagination
          @current-change="handleCurrentChange"
          @size-change="handleSizeChange"
          background
          layout="total, sizes, prev, pager, next, jumper"
          :total="pages.pageAll"
          :page-size="pages.pageSize"
        ></el-pagination>
      </div>
    </div>
    <div class="cl"></div>
  </div>
</template>

<script>
import link from "../../mixins/link";
import downLoad from "../../mixins/downLoad";
import axios from "axios";
export default {
  data() {
    return {
      treeData: [],
      defaultProps: {
        children: "children",
        label: "label",
        isLeaf: "leaf",
      },
      search: {
        resourceName: "",
        resourceTypeId: "",
        fileType: "",
        orgName: "",
        userName: "",
        year: "",
      },
      resourceTypeData: [],
      fileTypeData: [],
      yearData: [],
      sortOrder: "最新",
      data: [],
      data1: [],
      copyData: [],
      treeShow: false,
      clickData: {},
      breadcrumb1: [],
      previewUrl: "",
      uploadUrl: "",
      checkedCities: [],
      isIndeterminate: true,
      checkAll: false,
      tree: [],
      pages: { pageAll: 0, pageSize: 10, pagePage: 1 },
    };
  },
  mixins: [link, downLoad],
  props: {
    value: { type: Array },
    sectionData: { type: Array },
    breadcrumb: { type: Array },
    activeName: { type: String },
    breadcrumbData: { type: Object },
    init1: { type: Number },
    isList: { type: Boolean, default: true },
  },
  watch: {
    init1: {
      handler(n, o) {
        if (n != 0) {
          this.init();
        }
        // this.init();
      },
      immediate: true,
      deep: true,
    },
  },
  methods: {
    unit(v) {
      let arr = ["B", "KB", "MB", "GB", "TB"];
      let i = 0;
      while (v > 1024) {
        i++;
        v = Math.floor((v * 100) / 1024) / 100;
      }
      return v + arr[i];
    },
    handleCurrentChange(v) {
      this.pages.pagePage = v;
      this.getData(v);
    },
    handleSizeChange(v) {
      this.pages.pagePage = 1;
      this.pages.pageSize = v;
      this.getData(1, v);
    },
    copy(d) {
      let a = d.fileUrl.split("/")[1];
      axios
        .post(
          window.sessionStorage.getItem("uploadUrl") + "/" + a + "/copyfile",
          { Path: d.fileUrl },
          {
            headers: {
              "Content-Type": "multipart/form-data",
              clientId: window.sessionStorage.getItem("clientId"),
              token: window.sessionStorage.getItem("token"),
            },
          }
        )
        .then((res) => {
          if (res.data.suc) {
            let a = d.fileUrl.split("/");
            this.$emit("add", {
              thematicTypeId: "",
              resourceSource: 2,
              resourceName: d.resourceName,
              fileType: d.fileType,
              fileUrl: res.data.data.Path,
              fileSize: d.fileSize,
              resourceId: d.resourceId,
              type: "." + a[a.length - 1].split(".")[1],
            });
          } else {
            this.$message.error(res.data.msg);
          }
        });
    },
    init() {
      this.breadcrumb1 = this.breadcrumb;
      this.clickData = this.breadcrumbData;
      this.getSearch();
      this.getData();
      this.previewUrl = window.sessionStorage.getItem("previewUrl");
      this.uploadUrl = window.sessionStorage.getItem("uploadUrl");
      setTimeout(() => {
        this.treeShow = true;
      }, 10);
      this.tree = JSON.parse(window.sessionStorage.getItem("sectionData"));
    },
    treeClick(d, n, a) {
      this.clickData = n.data;
      if (n.level == 3) {
        this.clickData.firstChapterId = n.data.id;
      } else if (n.level == 4) {
        this.clickData.firstChapterId = n.parent.data.id;
        this.clickData.secondChapterId = n.data.id;
      } else if (n.level == 5) {
        this.clickData.firstChapterId = n.parent.parent.data.id;
        this.clickData.secondChapterId = n.parent.data.id;
        this.clickData.thirdChapterId = n.data.id;
      } else if (n.level == 6) {
        this.clickData.firstChapterId = n.parent.parent.parent.data.id;
        this.clickData.secondChapterId = n.parent.parent.data.id;
        this.clickData.thirdChapterId = n.parent.data.id;
        this.clickData.fourthChapterId = n.data.id;
      }

      this.getData();
    },
    goResource(i, j, k) {
      this.breadcrumb1[1] = i.label + j.label;
      this.clickData.sectionId = i.id;
      this.clickData.subjectId = j.id;
    },
    async loadNode(node, resolve) {
      let url;
      let sectionId;
      let subjectId;
      let versionId;
      let dataId;
      let chapterId;
      if (node.level == 0) {
        url =
          this.breadcrumb1.length == 2
            ? "/common/catalog/load/version"
            : this.breadcrumb1.length == 3
            ? "/common/catalog/load/volume"
            : this.breadcrumb1.length == 4
            ? "/common/catalog/load/chapter"
            : "";
        sectionId = this.breadcrumbData.sectionId;
        subjectId = this.breadcrumbData.subjectId;
        versionId =
          this.breadcrumb1.length < 3
            ? node.data
              ? node.data.versionId
              : ""
            : this.breadcrumbData.versionId;
        dataId =
          this.breadcrumb1.length < 4
            ? node.data
              ? node.data.dataId
              : ""
            : this.breadcrumbData.volumeId;
        chapterId = node.data ? node.data.chapterId : "";
      } else {
        url =
          node.data.type == "version"
            ? "/common/catalog/load/volume"
            : node.data.type == "volume"
            ? "/common/catalog/load/chapter"
            : node.data.type == "chapter"
            ? "/common/catalog/load/chapter"
            : "";
        sectionId = node.data.sectionId;
        subjectId = node.data.subjectId;
        versionId = node.data.versionId;
        dataId = node.data.dataId;
        chapterId = node.data.id;
      }
      let a = await this.$ajax.post(url, {
        sectionId: sectionId,
        subjectId: subjectId,
        versionId: versionId,
        chapterId: chapterId,
        dataId: dataId,
      });
      a.map((el) => {
        el.leaf = el.childCount == 0;
      });
      return resolve(a);
    },
    getData(v, s = 10) {
      let p = { size: this.pages.pageSize, page: this.pages.pagePage };
      Object.assign(p, this.search, this.clickData);
      let url =
        this.sortOrder == "最新"
          ? "/server/resource/center/listByDate"
          : this.sortOrder == "下载量"
          ? "/server/resource/center/listByDownload"
          : "/server/resource/center/listByFavorite";
      this.$ajax.post(url, p).then((res) => {
        this.data = res.list;
        this.pages.pageAll = res.total;
      });
    },
    getSearch() {
      this.$ajax.post("/common/load/resource/type").then((res) => {
        this.resourceTypeData = res;
      });
      this.$ajax.post("/common/load/share/year").then((res) => {
        this.yearData = res;
      });
      this.$ajax.post("/common/load/file/type").then((res) => {
        this.fileTypeData = res;
      });
    },
    cancelShare(id) {
      this.$ajax
        .post("/server/resource/common/cancelShare", {
          resourceId: id,
        })
        .then((res) => {
          this.data = this.data.filter((el) => el.resourceId != id);
        });
    },

    favorite(d) {
      this.$ajax
        .post("/server/resource/common/favorite", { resourceId: d.resourceId })
        .then((res) => {
          d.isFavorite = "N";
        });
    },
  },
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/page/special/quote.vue